export const COMMUNITY_BUZZ_BASE_URL = '/oram/community-buzz';
export const SOCIAL_SENTIMENTS_BASE_URL = '/oram/social-sentiments/sentiment';
export const DEFAULT_MAX_POLL_RETRIES = 5;
export const DEFAULT_POLL_RETRY_DELAY_MS = 15000;
